import styled from "styled-components";

/**
 * SwitchButton Component
 *
 * A reusable toggle switch UI component to control boolean states.
 *
 * @component
 *
 * @param {Object} props
 * @param {boolean} [props.switchStatus=true] - The current toggle state (ON/OFF).
 * @param {Function} props.setSwitchStatus - The function to update toggle state.
 * @param {string} [props.nameOfSwitch] - Optional label shown beside the switch.
 *
 * @returns {JSX.Element} The rendered toggle switch.
 */

export const SwitchButton = ({ switchStatus = true, setSwitchStatus, nameOfSwitch }) => {
  return (
    <SwitchBtnForContainerCss className="switchBtnForContainer" onClick={setSwitchStatus}>
      <SwitchButtonCss switchStatus={switchStatus}>
        <div className={`switch ${switchStatus ? "switchOn" : "switchOff"}`}></div>
      </SwitchButtonCss>
      <div>{nameOfSwitch}</div>
    </SwitchBtnForContainerCss>
  );
};

export const SwitchButtonV2 = ({ switchStatus = true, setSwitchStatus, nameOfSwitch = {} }) => {
  return (
    <SwitchBtnForContainerCss className="switchBtnForContainer fw-400" onClick={setSwitchStatus}>
      <div>{nameOfSwitch.left}</div>
      <SwitchButtonCss switchStatus={switchStatus}>
        <div className={`switch ${switchStatus ? "switchOn" : "switchOff"}`}></div>
      </SwitchButtonCss>
      <div>{nameOfSwitch.right}</div>
    </SwitchBtnForContainerCss>
  );
};

const SwitchBtnForContainerCss = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  padding-top: 4px;
  padding-bottom: 16px;
  &.fw-400 {
    font-weight: 400;
  }
`;

const SwitchButtonCss = styled.div.withConfig({
  shouldForwardProp: prop => prop !== "switchStatus",
})`
  border-radius: 100px;
  background: ${props =>
    props.switchStatus ? " var(--BLUE, #2060EA)" : "var(--LIGHT-GREY, #8C8CA1)"};
  width: 42px;
  height: 24px;
  padding: 3px;
  position: relative;
  cursor: pointer;

  > .switch {
    transition: left 0.5s ease;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    position: absolute;
    background-color: var(--Light---primary-background-color, #fff);
    left: ${props => (props.switchStatus ? "21px" : "3px")};
  }
`;

export const LabelForRadioButton = styled.label`
  display: flex;
  gap: 12px;
  align-items: center;
  input {
    display: none;
  }
  .radioBtn {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${props => (props.checked ? "#2060ea" : "#fff")};
    border: ${props => (props.checked ? "transparent" : "1px solid var(--LIGHT-GREY, #8C8CA1)")};
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 4px;
      left: 4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #fff;
      opacity: ${props => (props.checked ? 1 : 0)};
      transition: opacity 0.2s ease-in-out;
    }
  }
`;
